import OpenSeadragon from 'openseadragon';
import '@scss/modules/sketch-viewer';

const updateHash = (hash: string, mode: 'push' | 'replace' = 'push') => {
  if (window.location.hash === hash) {
    return;
  }

  if (mode === 'replace') {
    history.replaceState({}, '', hash);
    return;
  }

  history.pushState({}, '', hash);
};

const setupSketchViewer = () => {
  let suppressHistoryPush = false;

  const sketchViewer = OpenSeadragon({
    id: 'sketch-viewer',
    prefixUrl: '/wp-content/themes/core/assets/sketch/',
    sequenceMode: true,
    showNavigator: false,
    tileSources: [
      '/wp-content/themes/core/assets/sketch/rysunek-1/rysunek_1.js',
      '/wp-content/themes/core/assets/sketch/rysunek-2/rysunek_2.js',
      '/wp-content/themes/core/assets/sketch/rysunek-3/rysunek_3.js',
      '/wp-content/themes/core/assets/sketch/rysunek-4/rysunek_4.js',
      '/wp-content/themes/core/assets/sketch/rysunek-5/rysunek_5.js',
      '/wp-content/themes/core/assets/sketch/rysunek-6/rysunek_6.js',
    ],
    showFullPageControl: false,
    nextButton: 'sketch-next',
    previousButton: 'sketch-prev',
    zoomInButton: 'sketch-zoom-in',
    zoomOutButton: 'sketch-zoom-out',
    homeButton: 'sketch-home',
  });

  sketchViewer.addHandler('page', function(data) {
    if (suppressHistoryPush) {
      suppressHistoryPush = false;
      return;
    }

    updateHash(`#projects/sketch-${(data.page as number) + 1}`, 'push');
  });

  return {
    sketchViewer,
    suppressHistoryPushOnce: () => {
      suppressHistoryPush = true;
    },
  };
};

const setupHashWatch = (
  sketchViewer: OpenSeadragon.Viewer,
  suppressHistoryPushOnce: () => void,
) => {
  const hash = window.location.hash;
  const pageNumber = Number(hash.split('-')?.[1]);
  const isProjectView = hash.includes('projects/sketch') && pageNumber;

  if (isProjectView) {
    $('body').addClass('sketch-viewer-open');
    suppressHistoryPushOnce();
    sketchViewer.goToPage(pageNumber - 1);
  } else {
    $('body').removeClass('sketch-viewer-open');
  }
};

$(() => {
  const { sketchViewer, suppressHistoryPushOnce } = setupSketchViewer();

  $(document).on('click', '#sketch-close', () => {
    $('body').removeClass('sketch-viewer-open');
    updateHash('#projects', 'push');
  });

  $(window).on('hashchange', () => setupHashWatch(sketchViewer, suppressHistoryPushOnce));

  if (window.location.hash.includes('projects/sketch')) {
    setupHashWatch(sketchViewer, suppressHistoryPushOnce);
  }
});
